import styled from 'styled-components'

import { helpers } from '../../../../styles/theme'

export const Title = styled.a`
	color: ${helpers.color.textHeader};
	font-family: ${helpers.font.family.header};
	font-size: 16px;
	line-height: 15px;
	display: flex;
	align-items: center;
	column-gap: 8px;

	text-decoration: none;
	transition: color 100ms ease-in-out, background-color 100ms ease-in-out;
	cursor: pointer;

	&:focus,
	&:active {
		color: ${helpers.color.text};
		text-decoration: none;
	}

	&:hover {
		text-decoration: none;
		color: ${helpers.color.link};
	}
`
